export default __webpack_public_path__ + "static/semantic-motion-mapping-9bdf0cdbb75f17c9da8f1bb2529d01e4e39a923b1f8571808a473cd8babf5372.png";